import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/layout/home/home.component';
import { MainComponent } from './views/layout/main/main.component';
import { authGuard } from './auth/auth.guard';

import { PermissionService } from './permission.service';
import { UnauthorizedComponent } from './views/layout/unauthorized/unauthorized.component';
 
 
import { UserDetailsComponent } from './views/layout/post-call/user-details/user-details.component';
import { NewUserComponent } from './views/layout/post-call/new-user/new-user.component';

import { EmailRecordsComponent } from './views/layout/email-audit/email-records/email-records.component';
import { SurveyRecordsComponent } from './views/layout/survey-records/survey-records.component';
import { TextRecordsComponent } from './views/layout/text-records/text-records.component';
import { SurveyFeedbackComponent } from './views/layout/survey-feedback/survey-feedback.component';
import { AIAssistComponent } from './views/layout/aiassist/aiassist.component';

import { confirmationGuard } from './confirmation/confirmation.guard';
import { SettingsComponent } from './views/layout/settings/settings.component';
import { PageNotFoundComponent } from './views/layout/page-not-found/page-not-found.component';
import { userResolver } from './resolver/user.resolver';
import { AutoEmailRecordsComponent } from './views/layout/email/auto-email-records/auto-email-records.component';
import { DashboardComponent } from './views/layout/dashboard/dashboard.component';

import { IvrRecordsComponent } from './views/layout/ivr-records/ivr-records.component';
import { VoiceMailComponent } from './views/layout/voice-mail/voice-mail.component';
import { EmailFileuploadComponent } from './views/layout/email/email-fileupload/email-fileupload.component';
import { TextFileuploadComponent } from './views/layout/text-fileupload/text-fileupload.component';
import { LlmRunComponent } from './views/layout/llm-run/llm-run.component';
import { VoiceMailuploadComponent } from './views/layout/voice-mailupload/voice-mailupload.component';
import { VoiceMailConfigurationComponent } from './views/layout/voice-mail-configuration/voice-mail-configuration.component';
import { DocRecordsComponent } from './views/layout/document/doc-records/doc-records.component';
import { DocUploadComponent } from './views/layout/document/doc-upload/doc-upload.component';
import { AutoLoginComponent } from './components/auto-login/auto-login.component';

 

const routes: Routes = [
  {path:'login',component:HomeComponent},
  {path:'', redirectTo: 'login', pathMatch: 'full'},
  {path:'autologin',component:AutoLoginComponent},
  {path:'main', redirectTo: 'dashboard', pathMatch: 'full'},
  {path:'dashboard',component:DashboardComponent,
     canActivate:[authGuard],
  },
  {
    path:'main',
    component:MainComponent,
    
    canActivate:[authGuard],
    children:[
 
      
      {path:'settings', component:SettingsComponent,},
     

     
      {path:'textfileUpload',component:TextFileuploadComponent,canDeactivate:[confirmationGuard]},
       {path:'docfileUpload/:docid',component:DocUploadComponent,canDeactivate:[confirmationGuard]},
    
   
       {path:'voiceemailfileUpload',component:VoiceMailuploadComponent,canDeactivate:[confirmationGuard]},
      {path:'voiceMailRecords',component:VoiceMailComponent},
      {path:'surveyRecords', component:SurveyRecordsComponent,},
       {path:'ivrRecords', component:IvrRecordsComponent,},
      {path:'surveyFeedback', component:SurveyFeedbackComponent,},
      {path:'textRecords', component:TextRecordsComponent,},
      //{path:'autoEmailRecords',component:AutoEmailRecordsComponent},
      //{path:'docRecords',component:DocRecordsComponent},
      {path:'postcall',loadChildren:()=>import('../app/views/layout/post-call/post-call.module').then(m=>m.PostCallModule)},
      {path:'emailAudit',loadChildren:()=>import('../app/views/layout/email-audit/email-audit.module').then(m=>m.EmailAuditModule)},
      {path:'email',loadChildren:()=>import('../app/views/layout/email/email.module').then(m=>m.EmailModule)},
      {path:'contracts',loadChildren:()=>import('../app/views/layout/contracts/contracts.module').then(m=>m.ContractsModule)},
       {path:'rfpcontracts',loadChildren:()=>import('../app/views/layout/rfpcontract/rfpcontract.module').then(m=>m.RfpcontractModule)},
       {path:'infosecurity',loadChildren:()=>import('../app/views/layout/infosec/infosec.module').then(m=>m.InfosecModule)},
       {path:'document',loadChildren:()=>import('../app/views/layout/document/document.module').then(m=>m.DocumentModule)},
      {path:'doc-analytics',loadChildren:()=>import('../app/views/layout/doc-analytics/doc-analytics.module').then(m=>m.DocAnalyticsModule)},
      {path:'llmRun',component:LlmRunComponent},
      {path:'aiassist',component:AIAssistComponent},
      
         {
         path:'voiceMailconfiguration',
         component:VoiceMailConfigurationComponent,
         canActivate:[PermissionService],
          data:{ roles:['102'] }
        },
        {
          path:'unauthorized',
          component:UnauthorizedComponent
        }
      ]
  },
  {
    path:'**',component:PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
